export default __webpack_public_path__ + "static/rovo-multiple-indicators-dark-8475622c73f213516b75d240f9afba9c.png";